import { Component } from 'react'
import styled from '@emotion/styled'
import { get as _get } from 'lodash'
import { Box, Text } from 'stylewhere/components'
import { RowColumn } from 'stylewhere/api'

interface Props {
  row: any
  columns: RowColumn[]
}

export class TableRow extends Component<Props> {
  render() {
    const { row, columns } = this.props
    return (
      <Row row>
        {columns.map((col, idx) => {
          const value = _get(row, col.field)
          return (
            <Column key={row.id + '-' + idx} width={col.width ?? 160}>
              <Text style={{ textAlign: col.center ? 'center' : 'left' }}>{value ?? 'n/a'}</Text>
            </Column>
          )
        })}
      </Row>
    )
  }
}

const Row = styled(Box)`
  border-left: 2px solid #ddd;
`

const Column = styled(Box)`
  padding: 10px;
  border-right: 2px solid #ddd;
  border-bottom: 2px solid #ddd;
`
